//
import "../../css/profilecard.css";
import icon from "../../static/camera.png";
import Skeleton from "@mui/material/Skeleton";
//
const ProfileCard = ({
  name,
  email,
  phone,
  profilePic,
  handleUpload,
  isLoading,
}) => {
  //
  return (
    <div className="profile-card" style={{ position: "relative" }}>
      <div className="profile-pic">
        {profilePic ? (
          <>
            <div>
              {isLoading ? (
                <Skeleton
                  animation="wave"
                  variant="circular"
                  width={80}
                  height={80}
                />
              ) : (
                <img src={profilePic} alt={`${name}'s profile`} />
              )}

              <input
                type="file"
                id="_icon_id_upload"
                style={{ display: "none" }}
                onChange={(e) => handleUpload(e)}
              />
            </div>
          </>
        ) : (
          <div className="placeholder-pic">No Image</div>
        )}
      </div>
      <label htmlFor="_icon_id_upload" title="Change photo">
        <div class="change-icon">
          <img src={icon} alt="Change Icon" />
        </div>
      </label>
      <div className="profile-details">
        <p className="profile-name">{name}</p>
        <p className="profile-email">{email}</p>
        <p className="profile-phone">{phone}</p>
      </div>
    </div>
  );
};

export default ProfileCard;
